import { Injectable } from "@angular/core";

export enum DeviceType {

    desktop = 0,
    tablet = 1,
    smartphone = 2
}

export enum AspectRatioType {

    Unknown = -1,
    Format_16_9 = 0,
    Format_4_3 = 1,
}

@Injectable({
    providedIn: 'root',
})
export class MediaService {

    // data members

    deviceType = DeviceType.desktop;

    aspectRatioType = AspectRatioType.Format_16_9;

    get isDesktop() {

        return this.deviceType == DeviceType.desktop ? true : false;
    }

    get is16_9() {

        return this.aspectRatioType == AspectRatioType.Format_16_9 ? true : false;
    }

    private _width: number;
    get width() {
        return this._width;
    }

    private _height: number;
    get height() {
        return this._height;
    }

    // constructor

    constructor() {

        this.keepMediaQueries();
        this.updateMediaInformation();

        window.addEventListener("resize", () => {

            this.updateMediaInformation();
        });

        window.addEventListener("load", () => {

            this.updateMediaInformation();
        });
    }

    // private functions

    private keepMediaQueries() {

        this.deviceType = window.innerWidth > 1024 ? DeviceType.desktop : DeviceType.tablet;
    }

    private updateMediaInformation() {

        this._width = window.innerWidth;
        this._height = window.innerHeight;

        this.keepMediaQueries();
        this.keepWindowAspectRatio();
    }

    private gcd(width: number, height: number): number {
        return (height == 0) ? width : this.gcd(height, width % height);
    }

    private aspectRatio(width: number, gcd: number): number {
        return width / gcd;
    }

    private keepWindowAspectRatio() {

        let windowAspectRation = [this.aspectRatio(window.innerWidth, this.gcd(window.innerWidth, window.innerHeight)), this.aspectRatio(window.innerHeight, this.gcd(window.innerWidth, window.innerHeight))];

        let aspectRatio = windowAspectRation[0] / windowAspectRation[1];

        if (aspectRatio >= 16 / 9)
            this.aspectRatioType = AspectRatioType.Format_16_9;
        else
            this.aspectRatioType = AspectRatioType.Format_4_3;
    }

    private keepScreenAspectRatio() {

        let screenAspectRation = [this.aspectRatio(screen.width, this.gcd(screen.width, screen.height)), this.aspectRatio(screen.height, this.gcd(screen.width, screen.height))];

        if ((screenAspectRation[0] / screenAspectRation[1]).toFixed(1) == (16 / 9).toFixed(1))
            this.aspectRatioType = AspectRatioType.Format_16_9;
        else if ((screenAspectRation[0] / screenAspectRation[1]).toFixed(1) == (4 / 3).toFixed(1))
            this.aspectRatioType = AspectRatioType.Format_4_3;
        else
            this.aspectRatioType = AspectRatioType.Unknown;
    }
}

@Injectable({
    providedIn: 'root',
})
export class CssMediaService extends MediaService {

    // data members

    aspectRatioCss(css: string) {

        return this.is16_9 ? css + "16_9" : css;
    }

    deviceCss(css: string) {

        return this.isDesktop ? css : css + "mobile";
    }

    // constructor

    constructor() {

        super();
    }
}
